/*
  Scentsual BOGO picker
  Works with snippets/bogo-offer.liquid.
  1. A customer clicks "Choose free 100ml" in the cart.
  2. This picker opens (search, gender tabs), showing only scents available in that size.
  3. On pick, it adds the "Buy 1 Get 1 Free" product with both scents saved as properties,
     then removes one unit of the paid single bottle. If anything fails, it rolls back.
  4. The cart refreshes through the theme's own cart:update event.
  5. If free slots are unclaimed when the customer clicks Checkout, the picker opens once
     with an option to continue without the free bottle.
*/
(function () {
  'use strict';
  if (window.__scentsualBogo) return;
  window.__scentsualBogo = true;

  var CATALOG_URL = '/collections/all-perfumes/products.json';
  var SKIP_KEY = 'bogoSkippedSlots';

  var catalogPromise = null;
  var products = [];
  var ctx = null;
  var filter = 'all';
  var query = '';
  var busy = false;

  /* ---------- Styles ---------- */
  var style = document.createElement('style');
  style.textContent = [
    '.bogo-offer{margin:0 0 16px;padding:14px;border:1px solid #e8dcc6;border-radius:10px;background:#fdf8f2;text-align:left}',
    '.bogo-offer .bogo-offer__title{margin:0;font-weight:700;font-size:15px;color:#111}',
    '.bogo-offer .bogo-offer__sub{margin:4px 0 10px;font-size:12px;line-height:1.4;color:#6b6257}',
    '.bogo-offer .bogo-offer__row{display:flex;align-items:center;gap:10px;padding:8px 0;border-top:1px dashed #e0d4c0}',
    '.bogo-offer .bogo-offer__img{width:44px;height:44px;object-fit:cover;border-radius:6px;flex-shrink:0}',
    '.bogo-offer .bogo-offer__text{flex:1;min-width:0;display:flex;flex-direction:column}',
    '.bogo-offer .bogo-offer__with{font-size:12px;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.bogo-offer .bogo-offer__size{font-size:11px;color:#8a7f73}',
    '.bogo-offer .bogo-offer__btn{flex-shrink:0;width:auto;background:#111;color:#fff;border:0;border-radius:6px;padding:8px 12px;font-size:12px;font-weight:700;cursor:pointer}',
    '.bogo-offer .bogo-offer__btn:hover{background:#333}',
    'dialog.bogo-picker{position:fixed;inset:0 0 0 auto;margin:0;width:min(100vw,460px);max-width:100vw;height:100dvh;max-height:100dvh;padding:0;border:0;background:#fff;color:#111;flex-direction:column;box-shadow:-6px 0 32px rgba(0,0,0,.12)}',
    'dialog.bogo-picker[open]{display:flex}',
    'dialog.bogo-picker::backdrop{background:rgba(0,0,0,.5)}',
    '.bogo-picker *{box-sizing:border-box}',
    '.bogo-picker__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:18px 20px;border-bottom:1px solid #ebebeb;flex-shrink:0}',
    '.bogo-picker__title{margin:0;font-size:16px;font-weight:700}',
    '.bogo-picker__sub{margin:4px 0 0;font-size:12px;color:#6b6257}',
    '.bogo-picker__close{background:none;border:0;padding:6px;cursor:pointer;color:#555;border-radius:50%;line-height:0}',
    '.bogo-picker__close:hover{background:#f0f0f0;color:#111}',
    '.bogo-picker__search{padding:12px 16px;border-bottom:1px solid #ebebeb;flex-shrink:0}',
    '.bogo-picker__search input{width:100%;padding:10px 12px;border:1px solid #e0e0e0;border-radius:8px;font-size:14px;background:#f8f8f8;color:#111}',
    '.bogo-picker__search input:focus{outline:none;border-color:#c9a96e;background:#fff}',
    '.bogo-picker__tabs{display:flex;padding:0 16px;border-bottom:1px solid #ebebeb;overflow-x:auto;flex-shrink:0;scrollbar-width:none}',
    '.bogo-picker__tab{background:none;border:0;border-bottom:2px solid transparent;padding:12px 14px;font-size:13px;color:#777;cursor:pointer;white-space:nowrap;margin-bottom:-1px}',
    '.bogo-picker__tab[aria-selected="true"]{color:#111;border-bottom-color:#111;font-weight:700}',
    '.bogo-picker__list{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:4px 0}',
    '.bogo-picker__card{display:flex;align-items:center;gap:12px;padding:10px 16px;border-bottom:1px solid #f2f2f2}',
    '.bogo-picker__img{width:52px;height:52px;object-fit:cover;border-radius:6px;background:#f0ece6;flex-shrink:0}',
    '.bogo-picker__info{flex:1;min-width:0}',
    '.bogo-picker__name{font-size:13px;font-weight:600;line-height:1.35;margin:0 0 4px}',
    '.bogo-picker__badge{display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.3px;padding:2px 5px;border-radius:3px;border:1px solid currentColor;margin-right:4px}',
    '.bogo-picker__badge--Women{color:#c15d24}.bogo-picker__badge--Men{color:#7f3c2a}.bogo-picker__badge--Unisex{color:#c1a083}',
    '.bogo-picker__choose{flex-shrink:0;background:#111;color:#fff;border:0;border-radius:5px;padding:8px 14px;font-size:12px;font-weight:700;cursor:pointer}',
    '.bogo-picker__choose:disabled{background:#ccc;cursor:wait}',
    '.bogo-picker__msg{padding:48px 20px;text-align:center;color:#888;font-size:14px;margin:0}',
    '.bogo-picker__error{margin:0;padding:10px 16px;background:#fff5f5;color:#c0392b;font-size:13px;font-weight:600;border-top:1px solid #fecaca}',
    '.bogo-picker__foot{padding:14px 16px max(16px,env(safe-area-inset-bottom));border-top:1px solid #ebebeb;flex-shrink:0}',
    '.bogo-picker__skip{width:100%;background:none;border:1px solid #ccc;border-radius:5px;padding:12px;font-size:13px;color:#555;cursor:pointer}',
    '.bogo-picker button:focus-visible,.bogo-offer button:focus-visible{outline:2px solid #c9a96e;outline-offset:2px}'
  ].join('\n');
  document.head.appendChild(style);

  /* ---------- Picker markup ---------- */
  var dlg = document.createElement('dialog');
  dlg.className = 'bogo-picker';
  dlg.setAttribute('aria-labelledby', 'bogo-picker-title');
  dlg.innerHTML =
    '<div class="bogo-picker__head">' +
      '<div><p class="bogo-picker__title" id="bogo-picker-title"></p><p class="bogo-picker__sub"></p></div>' +
      '<button type="button" class="bogo-picker__close" aria-label="Close">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
    '</div>' +
    '<div class="bogo-picker__search"><input type="search" placeholder="Search fragrances" aria-label="Search fragrances" autocomplete="off"></div>' +
    '<div class="bogo-picker__tabs" role="tablist">' +
      '<button type="button" class="bogo-picker__tab" role="tab" data-filter="all">All</button>' +
      '<button type="button" class="bogo-picker__tab" role="tab" data-filter="Women">For Her</button>' +
      '<button type="button" class="bogo-picker__tab" role="tab" data-filter="Men">For Him</button>' +
      '<button type="button" class="bogo-picker__tab" role="tab" data-filter="Unisex">Unisex</button>' +
    '</div>' +
    '<div class="bogo-picker__list" role="list"></div>' +
    '<p class="bogo-picker__error" role="alert" hidden></p>' +
    '<div class="bogo-picker__foot" hidden><button type="button" class="bogo-picker__skip">Continue to checkout without my free fragrance</button></div>';

  var titleEl = dlg.querySelector('.bogo-picker__title');
  var subEl = dlg.querySelector('.bogo-picker__sub');
  var searchEl = dlg.querySelector('input');
  var tabEls = Array.prototype.slice.call(dlg.querySelectorAll('.bogo-picker__tab'));
  var listEl = dlg.querySelector('.bogo-picker__list');
  var errEl = dlg.querySelector('.bogo-picker__error');
  var footEl = dlg.querySelector('.bogo-picker__foot');

  document.body.appendChild(dlg);

  /* ---------- Helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tagsOf(p) {
    return (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
  }

  function genderOf(p) {
    var t = tagsOf(p);
    if (t.indexOf('women') !== -1) return 'Women';
    if (t.indexOf('men') !== -1) return 'Men';
    if (t.indexOf('unisex') !== -1) return 'Unisex';
    return '';
  }

  function sizeVariant(p, size) {
    var opts = p.options || [];
    var idx = -1;
    for (var i = 0; i < opts.length; i++) {
      if (String(opts[i].name || '').toLowerCase() === 'size') { idx = i; break; }
    }
    if (idx === -1) return null;
    var key = 'option' + (idx + 1);
    var vs = p.variants || [];
    for (var j = 0; j < vs.length; j++) {
      if (vs[j][key] === size) return vs[j];
    }
    return null;
  }

  function isSingle(p) {
    var t = tagsOf(p);
    if (t.indexOf('bogo-free') !== -1) return false;
    for (var i = 0; i < t.length; i++) {
      if (t[i].indexOf('bundle-') === 0) return false;
    }
    return !!(sizeVariant(p, '50ml') || sizeVariant(p, '100ml'));
  }

  function imageOf(p, width) {
    var src = p.images && p.images[0] && p.images[0].src;
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function suffix(g) { return g ? ' (' + g + ')' : ''; }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  async function postJSON(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }
    return data;
  }

  async function getCart() {
    var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Could not read your cart. Please refresh the page.');
    return res.json();
  }

  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'bogo',
        data: { source: 'bogo', itemCount: cart.item_count, sections: cart.sections || undefined }
      }
    }));
  }

  /* ---------- Catalogue ---------- */
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async function () {
      var all = [];
      for (var page = 1; page <= 20; page++) {
        var res = await fetch(CATALOG_URL + '?limit=250&page=' + page);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var data = await res.json();
        var batch = data.products || [];
        all = all.concat(batch);
        if (batch.length < 250) break;
      }
      products = all.filter(isSingle).sort(function (a, b) { return a.title.localeCompare(b.title); });
      return products;
    })();
    catalogPromise.catch(function () { catalogPromise = null; });
    return catalogPromise;
  }

  /* ---------- Rendering ---------- */
  function setFilter(f) {
    filter = f;
    tabEls.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.filter === f ? 'true' : 'false'); });
    render();
  }

  function render() {
    if (!ctx) return;
    if (!products.length && catalogPromise) {
      listEl.innerHTML = '<p class="bogo-picker__msg">Loading fragrances</p>';
      return;
    }
    var html = '';
    var count = 0;
    products.forEach(function (p) {
      var v = sizeVariant(p, ctx.size);
      if (!v || !v.available) return;
      var g = genderOf(p);
      if (filter !== 'all' && g !== filter) return;
      if (query && p.title.toLowerCase().indexOf(query) === -1) return;
      count++;
      var img = imageOf(p, 120);
      html +=
        '<div class="bogo-picker__card" role="listitem">' +
          (img ? '<img class="bogo-picker__img" src="' + esc(img) + '" alt="" width="52" height="52" loading="lazy">' : '<div class="bogo-picker__img"></div>') +
          '<div class="bogo-picker__info">' +
            '<p class="bogo-picker__name">' + esc(p.title) + '</p>' +
            (g ? '<span class="bogo-picker__badge bogo-picker__badge--' + g + '">' + (g === 'Women' ? 'For Her' : g === 'Men' ? 'For Him' : 'Unisex') + '</span>' : '') +
          '</div>' +
          '<button type="button" class="bogo-picker__choose" data-handle="' + esc(p.handle) + '">Choose</button>' +
        '</div>';
    });
    listEl.innerHTML = count ? html : '<p class="bogo-picker__msg">No fragrances match your search.</p>';
  }

  function showError(msg) {
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  /* ---------- Open and close ---------- */
  function open(btn, fromCheckout) {
    ctx = {
      lineKey: btn.dataset.lineKey,
      size: btn.dataset.size,
      pairVariant: Number(btn.dataset.pairVariant),
      paid: {
        title: btn.dataset.paidTitle,
        handle: btn.dataset.paidHandle,
        gender: btn.dataset.paidGender
      }
    };
    titleEl.textContent = 'Choose your free ' + ctx.size;
    subEl.textContent = fromCheckout
      ? 'You still have a free ' + ctx.size + ' to claim with your ' + ctx.paid.title + '.'
      : 'Free with your ' + ctx.paid.title + '. Any scent, same size.';
    footEl.hidden = !fromCheckout;
    errEl.hidden = true;
    query = '';
    searchEl.value = '';
    setFilter('all');

    if (!dlg.open) dlg.showModal();
    document.documentElement.style.overflow = 'hidden';

    loadCatalog().then(render).catch(function () {
      listEl.innerHTML = '<p class="bogo-picker__msg">Fragrances could not load. Please close this and try again.</p>';
    });
  }

  function close() {
    if (dlg.open) dlg.close();
  }

  dlg.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
    ctx = null;
  });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.querySelector('.bogo-picker__close').addEventListener('click', close);

  searchEl.addEventListener('input', function () {
    query = searchEl.value.toLowerCase().trim();
    render();
  });
  tabEls.forEach(function (t) {
    t.addEventListener('click', function () { setFilter(t.dataset.filter); });
  });

  /* ---------- Claim a free bottle ---------- */
  async function claim(handle, btn) {
    if (busy || !ctx) return;
    var p = null;
    for (var i = 0; i < products.length; i++) { if (products[i].handle === handle) { p = products[i]; break; } }
    if (!p) return;

    busy = true;
    errEl.hidden = true;
    listEl.querySelectorAll('.bogo-picker__choose').forEach(function (b) { b.disabled = true; });
    btn.textContent = 'Adding';

    var addedKey = null;
    try {
      var cart = await getCart();
      var line = null;
      for (var k = 0; k < cart.items.length; k++) { if (cart.items[k].key === ctx.lineKey) { line = cart.items[k]; break; } }
      if (!line) throw new Error('That bottle is no longer in your cart. Please close this and try again.');

      var added = await postJSON('/cart/add.js', {
        items: [{
          id: ctx.pairVariant,
          quantity: 1,
          properties: {
            'Size': ctx.size,
            'Paid fragrance': ctx.paid.title + suffix(ctx.paid.gender),
            'Free fragrance': p.title + suffix(genderOf(p)),
            '_bogo_paid_handle': ctx.paid.handle,
            '_bogo_free_handle': p.handle,
            '_bogo_free_image': imageOf(p, 250),
            '_bogo_id': Date.now().toString(36) + Math.random().toString(36).slice(2, 6)
          }
        }]
      });
      addedKey = added.items && added.items[0] && added.items[0].key;

      var updated = await postJSON('/cart/change.js', {
        id: ctx.lineKey,
        quantity: line.quantity - 1,
        sections: sectionIds(),
        sections_url: window.location.pathname
      });

      announce(updated);
      close();
    } catch (err) {
      if (addedKey) {
        try { await postJSON('/cart/change.js', { id: addedKey, quantity: 0 }); } catch (_) {}
      }
      showError(err.message || 'Something went wrong. Please try again.');
      try { announce(await getCart()); } catch (_) {}
      listEl.querySelectorAll('.bogo-picker__choose').forEach(function (b) { b.disabled = false; b.textContent = 'Choose'; });
    } finally {
      busy = false;
    }
  }

  listEl.addEventListener('click', function (e) {
    var b = e.target.closest('.bogo-picker__choose');
    if (b) claim(b.dataset.handle, b);
  });

  /* ---------- Open from the cart panel ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bogo-open]');
    if (!b) return;
    e.preventDefault();
    open(b, false);
  });

  /* ---------- Checkout reminder ---------- */
  function skippedCount() {
    try { return Number(sessionStorage.getItem(SKIP_KEY) || 0); } catch (_) { return 0; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout, button[name="checkout"]');
    if (!btn) return;
    var slots = document.querySelectorAll('.bogo-offer [data-bogo-open]');
    if (!slots.length || slots.length <= skippedCount()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(slots[0], true);
  }, true);

  dlg.querySelector('.bogo-picker__skip').addEventListener('click', function () {
    var slots = document.querySelectorAll('.bogo-offer [data-bogo-open]').length;
    try { sessionStorage.setItem(SKIP_KEY, String(slots)); } catch (_) {}
    close();
    window.location.href = '/checkout';
  });

  /* ---------- Preload the catalogue when a free slot exists ---------- */
  function preload() {
    if (document.querySelector('.bogo-offer')) loadCatalog().catch(function () {});
  }
  preload();
  document.addEventListener('cart:update', function () { setTimeout(preload, 500); });
})();